import { render, staticRenderFns } from "./EditData.vue?vue&type=template&id=3cfb0289&"
import script from "./EditData.vue?vue&type=script&lang=js&"
export * from "./EditData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports